export default "__VITE_ASSET__J6de4IZM__"